import React from 'react';

export default function Newerfront() {
  return (
    <div id="new2021MegaContainer-header">

        <header id="purple-h2021">
          <header id="topHeader2021">
						<a href="https://pacificio.com">pacificio.com</a>
            <a href="https://pacificio.com">
              <img src="/img/Mango-cutout--sticker-may2020.webp" id="mango-img" alt="parrot logo" />
            </a>
          </header>
          <section id="slogan2021">
            <span id="tag-line">design + development</span> 
          </section>
          <hr id="headerDivider" />
          <footer id="social-header">
            <a href="/wp">WordPress Coaching</a>{" · "}
            <a href="/static">JAM-stack Sites</a>{" · "}
            <a href="/stores">Custom Stores</a>{" · "}
            <a href="https://altaredwood.com">My Store</a>{" · "}
            <a href="https://pacificpelican.us9.list-manage.com/subscribe?u=32b56b1c860aa1eacf5411ad0&id=66b7185ce9">Email Updates</a>{" · "}
            <a href="/pay">Make a Payment</a>{" · "}
            <a href="/webinar">Web How-to</a>{" · "}
            <a href="/contact">Contact Me</a>
          </footer>
          <hr id="headerDivider2" />
          <aside id="footerLinks">

          </aside>
          <aside id="more-info">
            <span id="designed-info">
              At the intersection of storytelling and programming
            </span>
        	</aside>
          <br />
        </header>

      
      <style>
        {`
           :root {
            --uiFonts: "Ubuntu Mono", "Inconsolata", "Anonymous Pro", "Hack", Menlo,
              monospace;
            --contentFonts: "Lato", "Open Sans", "Lucida Grande", "Ubuntu Sans",
              "Segoe UI", "Roboto", Helvetica, sans-serif;
            --displayFonts: "Gentona", "Baufra", Georgia, serif;
            --monoFonts: "Anonymous Pro", "Hack", "Fira Sans", "Inconsolata", monospace;
            --textFontsDeprecated: "Calluna", "Caslon", "Garamond", serif;
            --systemFonts: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
            --huskyGoldLite: rgb(104, 91, 20);
            --huskyGold: #47473d;
            --huskyPurple: rgb(85, 73, 85);
            --uwPurple: #599ADA;
            --beigeColor: rgb(233, 233, 206);
          }
          html {
            box-sizing: border-box;
          }
          body {
            margin-top: 0px;
            margin-left: 0px;
            margin-right: 0px;
            padding-left: 0px;
            padding-right: 0px;
            margin-bottom: 0px;
          }
          header#topNav {
            background: var(--uwPurple, purple);
          }
          header#purple-h2021 {
            font-family: var(--contentFonts, Helvetica);
            color: #000000;
            background: #ffffff;
          }
          header#purple-h2021 a {
            color: #00030a;
          }
          header#purple-h2021 a:visited {
            color: #020a1c;
          }
          header#purple-h2021 a:hover {
            color: darkgreen;
          }
          header#purple-h2021 header,header#purple-h2021 section, header#purple-h2021 footer, aside#more-info  {
            padding-left: calc(1vw);
          }
          #topHeader2021, #topHeader2021 a {
            font-size: calc(2rem);
          }
          span#designed-info {
            font-size: calc(0.8rem);
            color: #1c0c0b;
          }
          section#splashImage {
            background-image: url("./img/Fourmile-Lake-Oregon-Sept-2019.jpg");
            margin-block-end: calc(0px);
          }
          section#newsAndEvents a{
            text-decoration: none;
          }
          h1#headline--heading, article#statement {
            color: white;
            font-family: var(--contentFonts, Helvetica);
          }
          a#readMoar, section#quickLinks, footer#next {
            background: rgba(255, 255, 255, 0.815);
            color: var(--huskyGold, gold);
            padding-inline-start: calc(1vw + 5px);
            padding-inline-end: calc(1vw + 5px);
            padding-block-start: calc(0.4vw + 5px);
            padding-block-end: calc(0.4vw + 5px);
            font-family: var(--systemFonts, sans-serif);
          }
          span#parrot, span#parrot a {
            font-size: calc(1.3rem);
          }
          section#quickLinks span {
            display: block;
            margin-block-start: calc(2.4vh + 10px);
          }
          a#newsAndEvents--box1__link___1, a#newsAndEvents--box1__link___2, a#newsAndEvents--box2__link___1, a#newsAndEvents--box3__link___1 {
            background: rgba(106, 158, 182, 0.815);
            color: var(--huskyGold, gold);
            padding-inline-start: calc(1vw + 5px);
            padding-inline-end: calc(1vw + 5px);
            padding-block-start: calc(0.4vw + 5px);
            padding-block-end: calc(0.4vw + 5px);
          }
          footer#readMore {
            margin-block-start: calc(2vh + 10px);
          }
          footer#readmore {
            margin-top: calc(10vh + 10px);
          }
          section#newsAndEvents {
            margin-block-start: calc(2vh + 10px);
          }
          section#newsAndEvents img {
            max-width: 99%;
          }
          section#newsAndEvents article {
            margin-left: calc(0.5vw);
            margin-right: calc(0.5vw);
            background: var(--beigeColor, beige);
            margin-bottom: calc(5px + 2vw);
            padding-block-start: calc(5px + 1vw);
            padding-block-end: calc(5px + 2vw);
            padding-inline-start: calc(5px + 1vw);
            padding-inline-end: calc(5px + 2vw);
          }
          header#newsAndEvents--box1__header {
            margin-inline-start: calc(0px);
            height: calc(10vh + 100px);
            background: red;
            background-image: url("./img/Mango-mini.jpg");
          }
          header#newsAndEvents--box2__header {
            height: calc(10vh + 100px);
            background: blue;
            background-image: url("./img/northcascades-crop.jpg");
          }
          header#newsAndEvents--box3__header {
            height: calc(10vh + 100px);
            background: green;
            background-image: url("./img/quarter-app-logo.png");
          }
          header#newsAndEvents--altaredwood__header {
            height: calc(10vh + 100px);
            background: green;
            background-image: url("./img/oregon-pin-pacificio-crop.jpg");
          }
          h2#newsAndEvents--header, h5#ff, footer#purple {
            text-align: center;
          }
          h2#newsAndEvents--header, footer#purple {
            margin-block-start: calc(25px + 3vh);
          }
          h1#topHeading, nav#firstNav {
            margin-top: calc(10px + 3vh);
            color: white;
          }
          nav#firstNav, h5#ff, footer#purple, h2#newsAndEvents--header, section#seondNav {
            font-family: var(--systemFonts, sans-serif);
          }
          nav#firstNav {
            margin-top: calc(10px + 2vh);
          }
          nav#firstNav li a {
            color: #edf0f7;
          }
          nav#firstNav li a:visited {
            color: #e4e7ed;
          }
          nav#firstNav li a:hover {
            color: #e4ede5;
          }
          span#topNav-logo {
            color: white;
            font-size: calc(2.1rem + 1.3em);
            opacity: 0.4;
          }
          div#search {
            color: white;
            font-size: calc(1.5rem + 1em);
            margin-top: calc(10px + 3vh);
          }
          footer a {
            color: inherit;
          }
          ul#secondNav--ul li a {
            text-decoration: none;
            font-weight: bold;
            color: #000721;
          }
          h1#topHeading a {
            color: inherit;
            text-decoration: none;
          }
          h1#topHeading a:hover {
            font-family: var(--contentFonts, sans-serif);
          }
          a#welcome__, section#quickLinks a {
            text-decoration: none;
          }
          aside#menu, section#quickLinks a {
            color: inherit;
          }
          aside#menu a {
            color: #000721;
          }
          #box1 h3 {
            color: #000721;
          }
          @media (max-width: 800px) {
            header#tagline {
              background: rgb(248, 244, 244);
              width: calc(33px + 12vh + 8vw);
              font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
              color: rgba(90, 78, 11, 0.596);
              font-weight: bold;
              font-style: italic;
              padding-inline-start: calc(1vw + 5px);
              padding-inline-end: calc(1vw + 5px);
              padding-block-start: calc(0.4vw + 5px);
              padding-block-end: calc(0.4vw + 5px);
            }
            div#innovates {
              margin-block-end: calc(9vw + 7px);
            }
            img#mango-img {
              width: calc(20vw + 10pt);
              float: right;
            }
            aside#menu {
              padding-inline-start: calc(1vw + 5px);
              padding-inline-end: calc(1vw + 5px);
              padding-block-start: calc(0.4vw + 5px);
              padding-block-end: calc(0.4vw + 5px);
            }
            h5#ff, section#fastFacts {
              padding-inline-start: calc(1vw + 5px);
              padding-inline-end: calc(1vw + 5px);
              padding-block-start: calc(0.4vw + 5px);
              padding-block-end: calc(0.4vw + 5px);
            }
            ul#secondNav--ul li, ul#firstNav--ul li {
              line-height: 1.4;
            }
            article.what-I-do, main#headline, div#logo, div#mainHeading {
              margin-left: calc(1vw + 4pt);
            }
            aside#menu  {
              line-height: 1.6;
            }
          }
          @media (min-width: 800px) {
            header#tagline {
              background: rgb(248, 244, 244);
              width: calc(20px + 10vh + 8vw);
              font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
              color: rgba(90, 78, 11, 0.596);
              font-weight: bold;
              font-style: italic;
              padding-inline-start: calc(1vw + 5px);
              padding-inline-end: calc(1vw + 5px);
              padding-block-start: calc(0.4vw + 5px);
              padding-block-end: calc(0.4vw + 5px);
            }
            header#topHeader2021 {
              margin-top: calc(1vw + 10pt);
            }
            img#mango-img {
              width: calc(5vw + 10pt);
              margin-left: calc(70vw);
            }
            ul#secondNav--ul {
              display: flex;
            }
            ul#secondNav--ul li {
              margin-right: calc(4vw + 4px);
              list-style: none;
            }
            ul#firstNav--ul li {
              list-style: none;
            }
            ul#firstNav--ul li:before {
              content: "/"; /* FontAwesome Unicode */
              font-family: "Hack", monospace;
            }
            ul#firstNav--ul li:first-child:before {
              content: "" !important; /* FontAwesome Unicode */
              font-family: "Hack", monospace;
            }
            header#topNav, nav#firstNav ul {
              display: flex;
              justify-content: space-evenly;
            }
            section#newsAndEvents article {
              width: calc(30vw + 20px);
            }
            header#topNav {
              height: calc(10vh + 27px);
            }
            /* ul#secondNav--ul li:after {
              content: ">";
            } */
            section#splashImage {
              height: calc(100px + 60vh);
              padding-left: calc(20px + 3vw);
            }
            article#statement {
              width: calc(40vw + 40px);
              line-height: 1.4;
            }
            hr#splashImage--hr {
              display: none;
            }
            footer#next {
              margin-left: calc(50vw + 100px);
              margin-top: calc(20vh + 20px);
            }
            aside#menu {
              display: flex;
            }
            aside#menu {
              background: var(--beigeColor, beige);
              padding-block-start: calc(0px);
              padding-block-end: calc(0px);
            }
            aside#menu section {
              background: white;
              margin-inline-start: calc(1vw + 5px);
              width: calc(12vw + 10px);
              font-family: var(--displayFonts, monospace);
            }
            aside#menu section:before {
              content: "🔗";
            }
            section#newsAndEvents {
              display: flex;
            }
            div#fastFacts--card1, div#fastFacts--card2, section#fastFacts {
              display: flex;
              justify-content: space-evenly;
            }
            footer#purple {
              background: var(--uwPurple, purple);
              color: var(--beigeColor, beige);
              margin-block-end: calc(0px);
            }
            footer#purple hr {
              width: calc(20vw + 5px);
            }
          }
        `}
      </style>
    </div>
  )
}
